export const HEADER_HEIGHT = 40; // px
